<ng-container *transloco="let t">
  <div class="title-row">
    <h2>{{ t("admin") }}</h2>
  </div>
  <div class="main-content">
    @for (group of structure; track group.groupName) {
      @let items = getAuthorizedItems(group);
      @if (items.length > 0) {
        <div class="group-section">
          <p class="group-name">{{ t(group.groupName) }}</p>
          <div class="group-items-container">
            @for (item of items; track item.link) {
              <a [class]="'group-item ' + item.color" [routerLink]="item.link">
                <span class="material-symbols-outlined item-icon">{{
                  item.icon
                }}</span>
                <p class="item-title">{{ t(item.name) }}</p>
              </a>
            }
          </div>
        </div>
      }
    }
  </div>
</ng-container>
